import { IonIcon } from "@ionic/react";
import { eyeOutline } from "ionicons/icons";
import { useEffect, useState } from "react";
import { Badge, Col, Row } from "react-bootstrap";
import getHost from "utils/url";
import { useWebSocket } from "../../providers/WebSocketProvider";
import SourceActions from './SourceActions';
import SourceState from "./SourceState";

const SourceItem = ({ item, profiles, compact }) => {

    const [source, setSource] = useState(item);
    const [showMenu, setShowMenu] = useState(false);

    const [listenerReady, setListenerReady] = useState(false);


    const [showSource, setShowSource] = useState(true);

    const sockets = useWebSocket()

    useEffect(() => {

        if (sockets && sockets.length > 0) {

            if (listenerReady) {
                return
            }

            setListenerReady(true)

            sockets.forEach(socketObj => {
                socketObj.listenerReady = true
                socketObj.socket.addEventListener('message', handleSocketsMessages);
            })
        }

        return () => {
            if (sockets) {
                sockets.forEach(socketObj => {
                    socketObj.socket.removeEventListener('message', handleSocketsMessages);
                });
            }
        };

    }, [sockets]);



    const handleSocketsMessages = (event, socketObj) => {


        const json = JSON.parse(event.data)

        if (json.id !== item.id) {
            return
        }

        //setToasts((prevMensajes) => [...prevMensajes, json]);

        switch (json.action) {
            case 'start':
                setSource(prev => ({ ...prev, state: 1 }));
                break;
            case 'starting':
                setSource(prev => ({ ...prev, state: 3 }));
                break;
            case 'fail':
                setSource(prev => ({ ...prev, state: 4 }));
                break;
            case 'stop':
                setSource(prev => ({ ...prev, state: 0 }));
                break;
            case 'enable':
                setSource(prev => ({ ...prev, status: true }));
                break;
            case 'disable':
                setSource(prev => ({ ...prev, status: false }));
                break;
            default:
                break;
        }
    }

    const outputs = source.outputs.filter((valor) => valor.isBackup === false);



    const CodecVideo = ({ info }) => {
        if (!info) {
            return (<></>)
        }
        var json = JSON.parse(info)
        return (
            <>

                <Badge bg="primary">{json.codecVideo && <>{json.codecVideo}</>}</Badge>
                {' '}
                <Badge bg="secondary">{json.width}x{json.height}</Badge>

            </>
        )
    }

    const CodecAudio = ({ info }) => {
        if (!info) {
            return (<></>)
        }
        var json = JSON.parse(info)
        return (
            <>
                <Badge bg="primary">{json.codecAudio && <>{json.codecAudio}</>}</Badge>
                {' '}
                <Badge bg="secondary">{json.channels}ch - {json.sampleRate}hz</Badge>

            </>
        )
    }

    const EncodingInfo = ({ profile }) => {

        if (profile?.codecVideo === 'copy') {
            return (
                <>
                    <Badge bg='dark'>Copy</Badge>
                </>
            )
        } else if (profile?.resolution) {
            return (
                <>
                    <Badge bg='dark'>
                        {profile.codecVideo && <>{profile.codecVideo.replace('libx264', 'h264')}</>}
                        {'/'}
                        {profile.resolution && <>{profile.resolution.split('x')[1]}p</>}
                        {'/'}
                        {profile.preset && <>{profile.preset}</>}
                    </Badge>
                    {' '}
                    {profile.codecAudio !== 'copy' &&
                        <Badge bg='dark'>
                            {profile.codecAudio && <>{profile.codecAudio}</>}
                            {'/'}
                            {profile.bitrateAudio && <>{profile.bitrateAudio}kb</>}
                        </Badge>
                    }
                </>
            )
        }
        return (<></>)

    }

    function calculateTimeElapsed(seconds) {
        // Calculate the current time in seconds
        var currentSeconds = Math.floor(Date.now() / 1000);

        // Calculate the time difference
        var elapsedSeconds = currentSeconds - seconds;

        // If the elapsed time is less than 1 hour
        if (elapsedSeconds < 3600) {
            let minutes = Math.floor(elapsedSeconds / 60);
            var remainingSeconds = elapsedSeconds % 60;

            return `${minutes}m,${remainingSeconds}s`;
        }

        // Calculate days, hours, and minutes
        var days = Math.floor(elapsedSeconds / (24 * 60 * 60));
        var hours = Math.floor((elapsedSeconds % (24 * 60 * 60)) / (60 * 60));
        var minutes = Math.floor((elapsedSeconds % (60 * 60)) / 60);

        // Build the formatted time elapsed string
        var result = '';
        if (days > 0) {
            result += days + 'd';
        }
        if (hours > 0) {
            result += (result === '' ? '' : ',') + hours + 'h';
        }
        if (minutes > 0) {
            result += (result === '' ? '' : ',') + minutes + 'm';
        }

        // If no time has passed, consider it as 0 minutes
        if (result === '') {
            result = '0m';
        }

        return result;
    }


    return (
        <>
            <Col md={4}>

                <div className={`source-item ${source.status ? '' : 'source-disabled'}`} onMouseEnter={() => { setShowMenu(true) }} onMouseLeave={() => { setShowMenu(false) }}>
                    <Row className="justify-content-between">
                        <Col xs={9}>
                            <a className="text-decoration-none text-truncate d-block" href={`/sources/${source.id}`}>
                                <span className="small text-success">{source.id}</span>
                                {' '}
                                <span className="fs-5 text-truncate"> {source.name}</span>
                            </a>
                        </Col>
                        <Col xs={3} className="text-end">
                            <SourceState state={source.state} />
                        </Col>
                    </Row>

                    <Row className="justify-content-end mt-3">
                        <Col xs={6} md={7}>
                            <span className="fs-6 fw-bold">Fuente</span>
                            <br />
                            {showSource &&
                                <span className="d-block font-monospace text-truncate">{getHost(source.state === 2 ? source.urlBackup : source.url)}</span>
                            }
                            {!showSource &&
                                <>
                                    <span>***</span>
                                    {' '}
                                    <span><IonIcon icon={eyeOutline} onClick={() => setShowSource(true)} /></span>
                                </>
                            }
                        </Col>
                        {(source.state === 1 || source.state === 2) &&
                            <Col xs={3}><span className="fs-6 fw-bold">Online</span><br /><span className="font-monospace">{calculateTimeElapsed(source.time)}</span></Col>
                        }
                        <Col xs={3} md={2}><span className="fs-6 fw-bold">Server</span><br /><span className="font-monospace">{source.server}</span></Col>
                    </Row>

                    {!compact &&
                        <>
                            <div className="mt-3 mb-2 fs-6 fw-bold">Codecs</div>
                            <Row>
                                <Col md={6}>
                                    <CodecVideo info={source.info} /><br />
                                </Col>
                                <Col md={6}>
                                    <CodecAudio info={source.info} />
                                </Col>
                            </Row>

                            <div className="mt-3 mb-2 fs-6 fw-bold">Salidas</div>
                            <ul className="codecs-list">
                                {outputs.map((output, index) => {
                                    const profile = profiles.find(profile => profile.id === output.profileId);
                                    return (
                                        <li key={index} className="small fs-6">
                                            <Row className="row-cols-3">
                                                <Col xs={5} className="text-truncate">
                                                    {output.name}
                                                </Col>
                                                <Col xs={7}>
                                                    <EncodingInfo profile={profile} />
                                                </Col>
                                            </Row>

                                        </li>
                                    )
                                })}
                            </ul>
                        </>
                    }

                    {/*
                        <Row>
                            <Col md={5}>
                                <div className="mt-3 mb-2 fs-6 fw-bold">Codecs</div>
                                <CodecVideo info={source.info} /><br />
                                <CodecAudio info={source.info} />
                            </Col>

                            <Col md={7}>
                                <div className="mt-3 mb-2 fs-6 fw-bold">Salidas</div>
                                <ul className="codecs-list">
                                    {outputs.map((output, index) => {

                                        const profile = profiles.find(profile => profile.id === output.profileId);

                                        return (
                                            <li key={index} className="small fs-6">
                                                {output.name} <EncodingInfo profile={profile} />
                                            </li>
                                        )
                                    })}
                                </ul>
                            </Col>
                        </Row>
                                */}




                    <div className="justify-content-end text-end" style={{ minHeight: '24px' }}>
                        {
                            showMenu &&
                            <SourceActions sourceId={source.id} state={source.state} status={source.status} server={source.server ? source.server : 1} />
                        }
                    </div>

                </div>

            </Col>


        </>
    );
}

export default SourceItem;